import NewspaperIcon from "@mui/icons-material/Newspaper";
import React from "react";

const Blog = [
  [
    "Blog",
    "/admin/blog",
    <NewspaperIcon sx={{ fontSize: "2rem", ml: "0.3rem" }}></NewspaperIcon>,
  ],
];

export default Blog;
